/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getAppPopupTable = params => {
  return axios.post(`${base}/popup/query`, params)
}
export const getAppPopupDetail = params => {
  return axios.get(`${base}/popup/get_${params.id}`, {params})
}
export const exportAppPopupData = params => {
  return axios.get(`${base}/popup/query/${params.id}`, {params})
}
export const createAppPopupData = params => {
  return axios.post(`${base}/popup/create`, params)
}
export const updateAppPopupData = params => {
  return axios.post(`${base}/popup/edit_${params.id}`, params)
}
export const changeStatus = params => {
  return axios.post(`${base}/popup/changeStatus`, params)
}
export const uploadImgFile = params => {
  return axios.post(`${base}/popup/uploadImgFile`, params)
}



// WEBPACK FOOTER //
// ./src/views/app-popup/app-popup.api.js